import { Gourmetta } from '@gourmetta-bestellsystem/types';
const baseShopConfiguration = {
    logoPath: '/gourmetta-logo.svg',
    slug: 'market',
    company: Gourmetta.ImportSource.Master,
    locales: ['de'],
    defaultLocale: 'de',
    defaultContact: 'email@gourmetta.com',
    requestProductLink: 'https://forms.office.com/r/rjbf7BzHip',
    showRequestProductLink: false,
    productsPageSize: 16,
    filters: {
        showSupplierFilter: true,
    },
    shoppingCart: {
        showSeparationBySupplier: true,
    },
    productInfo: {
        showExternalBcVendorId: true,
        showSupplierTitle: true,
    },
    productPricing: {
        useSellingPrice: false,
    },
    productDetail: {
        showDetailModal: false,
    },
    delivery: {
        excludeWeekends: true,
    },
    orderType: 'order',
    registrationOrigin: 'registration_form',
};
/**
 * Die Shop-Datensätze in Directus, als benannte Konstanten.
 *
 * Sie standen bis dahin an drei Stellen als nackte UUID: hier als Schlüssel,
 * im BC-Import als Ziel neuer Kunden und in der E2E-Suite. Eine Quelle reicht.
 */
export const SHOP_IDS = {
    market: '3155133a-943b-48fa-8cc9-679f53da1c09',
    nonfood: '45cf9308-e8b8-4075-9ab9-4589150cb446',
};
const shopConfigurations = {
    // Market Gourmetta
    [SHOP_IDS.market]: {
        ...baseShopConfiguration,
    },
    // API-NonFood
    [SHOP_IDS.nonfood]: {
        ...baseShopConfiguration,
        logoPath: '/api-logo.png',
        slug: 'nonfood',
        /**
         * Der Master, nicht `077_02`: die Stammdaten kommen von dort.
         * Vor der Mandantenumstellung stand hier `NonFood`, danach `undefined` —
         * und `getUnitOfMeasures` gibt bei `undefined` eine leere Liste zurück,
         * der Shop hatte also keine Maßeinheiten mehr.
         */
        company: Gourmetta.ImportSource.Master,
        locales: ['fr'],
        defaultLocale: 'fr',
        defaultContact: 'marcel@api-nonfood.com',
        filters: {
            showSupplierFilter: false,
        },
        shoppingCart: {
            showSeparationBySupplier: false,
        },
        productInfo: {
            showExternalBcVendorId: false,
            showSupplierTitle: false,
        },
        productPricing: {
            useSellingPrice: true,
        },
        productDetail: {
            showDetailModal: true,
        },
        delivery: {
            excludeWeekends: false,
        },
        orderType: 'purchaseOrder',
        registrationOrigin: 'registration_form_nonfood',
    },
};
export const getConfig = (shopIdParam) => {
    var _a;
    const shopId = (_a = shopIdParam !== null && shopIdParam !== void 0 ? shopIdParam : process.env.NEXT_PUBLIC_SHOP_ID) !== null && _a !== void 0 ? _a : '';
    const shopConfiguration = shopConfigurations[shopId];
    if (!shopConfiguration) {
        throw new Error(`No shop configuration found for id ${shopId}`);
    }
    return shopConfiguration;
};
